<script>
  import { onMount, onDestroy } from 'svelte';
  import { getGroupStore } from '@stores/group';
  let searchTermStore = getGroupStore('searchTermStore');
  let recObjectsStore = getGroupStore('recObjectsStore');
  import _ from 'lodash-es';

  export let recObjectId;
  export let mobile = false;
  export let viewStyle = 'column';
  export let showAll = false;
  export let spanStyle = '';
  export let clickable = true;

  let categories = [];
  let categoriesToShow = [];
  let recObject = recObjectsStore.find(recObjectId);
  let unsubRecObject = recObject.subscribe((x) => {
    recObject = x;

    if (!_.isEqual(categories, recObject.categories)) {
      categories = recObject.categories;
    }

    if (categories && categories.length === 0) {
      categoriesToShow = [];
    }
  });

  let mounted = false;
  let el;

  $: if (mounted && categories && categories.length > 0) {
    computeCategoriesToShow();
  }

  export let showAllCategories = function (cats) {
    categoriesToShow = cats;
  };

  let computeCategoriesToShow = function () {
    categoriesToShow = JSON.parse(JSON.stringify(categories)).slice(0);
    setTimeout(showOnlyCategoriesInOneLine, 0);
  };

  let showOnlyCategoriesInOneLine = function () {
    if (showAll == false && categoriesToShow.length > 1 && el && el.offsetHeight > 22) {
      categoriesToShow.pop();
      categoriesToShow = categoriesToShow;
      setTimeout(showOnlyCategoriesInOneLine, 0);
    }
  };

  let searchCategory = function (category) {
    var term = category.name.trim();
    searchTermStore.set({ term: term });
  };

  onMount(() => {
    mounted = true;
  });

  onDestroy(() => {
    unsubRecObject();
  });
</script>

<style style="text/scss" lang="scss">
  .ui-category {
    transition: 0.1s;
    margin-top: 5px;
    color: #8e71ff;
    border: 1px solid rgba(255, 255, 255, 0.104076);
    border-radius: 9px;
    font-weight: 400;
    font-size: 15px;
    line-height: 15px;
  }

  .ui-category-clickable {
    &:hover {
      cursor: pointer;
      color: #7054dc;
    }
  }

  .mobile {
    .ui-category {
      font-size: 13px !important;
      line-height: 19px !important;
    }
  }

  .grid {
    .ui-category {
      font-weight: 500 !important;
      font-size: 13px !important;
    }
  }

  .grid.mobile {
    line-height: 20px !important;
    margin-top: 4px !important;

    .ui-category {
      font-size: 16px !important;
      line-height: 20px !important;
    }
  }
</style>

<div class:mobile={mobile} class={viewStyle} style="line-height: 22px;" bind:this={el}>
  {#each categoriesToShow as category, i}
    {#if clickable}
      <span
        style={spanStyle}
        class="ui-category ui-category-clickable"
        on:click|preventDefault|stopPropagation={() => {
          searchCategory(category);
        }}>
        {i < categories.length - 1 ? `${category.name.trim()}, ` : `${category.name.trim()}`}
      </span>
    {:else}
      <span style={spanStyle} class="ui-category">
        {i < categories.length - 1 ? `${category.name.trim()}, ` : `${category.name.trim()}`}
      </span>
    {/if}
  {/each}
  {#if categories.length > categoriesToShow.length}
    <span
      style={spanStyle}
      class="ui-category"
      on:click|preventDefault|stopPropagation={() => {
        showAllCategories(categories);
      }}>
      + {categories.length - categoriesToShow.length} more
    </span>
  {/if}
</div>
